import { Link } from "gatsby";
import React from "react";
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";

interface BottomNavigationProps {
  prev?: {
    to: string;
    label: string;
    icon?: React.ReactNode;
  };
  next?: {
    to: string;
    label: string;
    icon?: React.ReactNode;
  };
  className?: string;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({
  prev,
  next,
  className = "",
}) => {
  return (
    <div
      style={{
        marginTop: "40px",
        marginBottom: "20px",
        fontFamily: "Work Sans",
        fontSize: "18px",
      }}
      className={`flex w-full justify-between text-sm font-semibold items-center leading-[1] text-site-blue-dark ${className}`}
    >
      <div>
        {prev && (
          <Link to={prev.to}>
            <div className="flex items-center gap-1">
              <div className="w-5xl flex justify-center items-center">
                <IoIosArrowDropleftCircle size={64} color="#00b8a4" />
              </div>
              <div className="flex-1 min-w-0 pr-2">
                <span className="whitespace-normal">{prev.label}</span>
              </div>
            </div>
          </Link>
        )}
      </div>
      <div>
        {next && (
          <Link to={next.to}>
            <div className="flex items-center gap-1 text-right">
              <div className="flex-1 min-w-0 pl-2">
                <span className="whitespace-normal">{next.label}</span>
              </div>
              <div className="w-5xl flex justify-center items-center">
                {next.icon || (
                  <IoIosArrowDroprightCircle size={64} color="#00b8a4" />
                )}
              </div>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};

export default BottomNavigation;
